import { render, staticRenderFns } from "./gardesh_1.vue?vue&type=template&id=4edfcab7"
import script from "./gardesh_1.vue?vue&type=script&lang=js"
export * from "./gardesh_1.vue?vue&type=script&lang=js"
import style0 from "./gardesh_1.vue?vue&type=style&index=0&id=4edfcab7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports